import {
	ChangeDetectionStrategy,
	Component,
	inject,
	OnInit,
} from '@angular/core';
import { MatterMortgageWithAssociations } from '@models/mortgage';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import {
	MatterMortgageDispatch,
	MatterMortgagesState,
} from '@state/matter/matter_mortgages';
import { Observable } from 'rxjs';

@UntilDestroy()
@Component({
	selector: 'app-closer-sync-reporting',
	templateUrl: './closer-sync-reporting.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CloserSyncReportingComponent implements OnInit {
	@Select(MatterMortgagesState.getSelectedMortgage)
	mortgage$: Observable<MatterMortgageWithAssociations>;
	private mortgageDispatch = inject(MatterMortgageDispatch);
	public _mortgage: MatterMortgageWithAssociations;

	ngOnInit(): void {
		this.mortgage$.pipe(untilDestroyed(this)).subscribe((mortgage) => {
			this._mortgage = mortgage;
		});
	}

	updateRegistrationDate($event: string): void {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			registrationDate: $event,
		});
	}

	updateRegistrationNumber($event: string): void {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			registrationNumber: $event,
		});
	}

	updateAssignmentOfRentsRegDate($event: string): void {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			assignmentOfRentsRegDate: $event,
		});
	}

	updateAssignmentOfRentsRegNumber($event: string): void {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			assignmentOfRentsRegNumber: $event,
		});
	}

	updateAssignmentOfRentsPpsaRegNumber($event: string): void {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			assignmentOfRentsPpsaRegNumber: $event,
		});
	}

	updateGeneralSecurityAgreementRegDate($event: string) {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			generalSecurityAgreementRegDate: $event,
		});
	}

	updateGeneralSecurityAgreementRegNumber($event: string) {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			generalSecurityAgreementRegNumber: $event,
		});
	}

	setHideRegistrationFee(value: boolean): void {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			hideRegistrationFee: value,
		});
	}

	setAssignmentOfRents(value: boolean): void {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			assignmentOfRents: value,
		});
	}

	setGeneralSecurityAgreement(value: boolean): void {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			generalSecurityAgreement: value,
		});
	}
}
